/**
 * 获取cookie中指定字段的值
 * @param {String} name
 */
const getCookie = (name) => {
  const value = '; ' + document.cookie;
  const parts = value.split('; ' + name + '=');
  if (parts.length === 2) {
    const cookieValue = parts.pop().split(';');
    if (cookieValue instanceof Array) {
      return cookieValue.shift();
    }
  }
};
export default getCookie;
